import { useState, useEffect } from 'react';
import { Container } from '../../Container/Container';
import BackButton from '../../BackButton/BackButton';
import Card from './components/Card/Card';
import Cookies from 'react-cookies';
import { getFavorites, getFavoritesFull } from '../../../helpers/favorites';
import styles from './FavoritesPage.module.scss';

import { updateFavorites } from '../../../helpers/favorites';
import { ICardProps } from './components/Card/Card';
import Pagination from '../CatalogPage/components/Pagination/Pagination';

const FavoritesPage = () => {
  const [list, setList] = useState<
    {
      item: ICardProps;
      type: 'product' | 'part' | 'accessory';
      itemId: string;
    }[]
  >([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalDocs, setTotalDocs] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [hasNextPage, setHasNextPage] = useState<boolean>(false);

  const deleteFavorite = (item: ICardProps) => {
    updateFavorites(item, 'delete');
    setList((state) => state.filter((i) => i.itemId !== item.id));
  };

  const updatePage = (page: number) => {
    setCurrentPage(page);
  };

  const updateLimit = (value: number) => {
    setLimit(value);
  };

  useEffect(() => {
    getFavoritesFull(limit, currentPage).then((res) => {
      setList(res?.docs || []);
      setTotalPages(res?.totalPages || 1);
      setTotalDocs(res?.totalDocs || 0);
      setHasNextPage(res?.hasNextPage || false);
    });
  }, [currentPage]);

  useEffect(() => {
    getFavoritesFull(limit, 1).then((res) => {
      setList(res?.docs || []);
      setTotalPages(res?.totalPages || 1);
      setTotalDocs(res?.totalDocs || 0);
      setHasNextPage(res?.hasNextPage || false);
      setCurrentPage(1);
    });
  }, [limit]);

  useEffect(() => {
    if (!Cookies.load('isUser')) {
      getFavorites().then((arr) =>
        setList(
          arr.map((i) => {
            return { item: i, type: i.type, itemId: i.id };
          }),
        ),
      );
    } else {
      getFavoritesFull().then((res) => {
        setList(res?.docs || []);
        setTotalPages(res?.totalPages || 1);
        setTotalDocs(res?.totalDocs || 0);
        setHasNextPage(res?.hasNextPage || false);
      });
    }
  }, []);

  return (
    <div className={styles.FavoritesPage}>
      <Container>
        <BackButton />
        <h1>Избранное</h1>
        {list.length ? (
          list.map((item, index) => (
            <Card
              key={index}
              item={{ ...item.item, id: item.itemId, type: item.type }}
              deleteItem={deleteFavorite}
            />
          ))
        ) : (
          <p>Здесь пока пусто или вы не авторизованы</p>
        )}
        {list.length > limit ? (
          <Pagination
            count={totalPages}
            currentPage={currentPage}
            updatePage={updatePage}
            updateLimit={updateLimit}
            showMore={() => setCurrentPage((prev) => prev + 1)}
            remainder={hasNextPage ? totalDocs : 0}
            shoeMoreCount={hasNextPage ? totalDocs - currentPage * limit : 0}
            limit={limit}
          />
        ) : null}
      </Container>
    </div>
  );
};

export default FavoritesPage;
